// UpdateResource.jsx
import React, { useEffect, useState,useRef } from "react";
import { createPortal } from "react-dom";

import { useParams } from "react-router-dom";
import {
  fetchRoles,
  fetchDepartments,
  fetchBanks,
  fetchEmployeeTypes,
  fetchPaymentGroups,
  fetchCostCenters,
  fetchOfficeCodes,
  fetchPaymentBanks,
  fetchSalaryConfig,
} from "../Api/ResourceMaster";
import { getCompanyCodesByOrganisation } from "../Api/CustomerMaster";
import { Form, Button, Row, Col, Accordion } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import axios from "axios";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import {
  FaUser,
  FaIdCard,
  FaUniversity,
  FaMoneyBillWave,
  FaUserTie,
  FaUsers,
    FaFileAlt 
} from "react-icons/fa";
import DocumentsSection from "../Components/DocumentsSection";
import { hrDocumentService, hrQualificationService } from "../Api/hrDocumentService";
const UpdateResource = () => {
  const { id } = useParams();
  const { user } = useAuth();
const stationInputRef = useRef(null);


const [stationDropdownStyle, setStationDropdownStyle] = useState({});


// const [showStationDropdown, setShowStationDropdown] = useState(false);
// const [stationDropdownStyle, setStationDropdownStyle] = useState({});

  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(true);
  const [showSpouseName, setShowSpouseName] = useState(false);
  const [managers, setManagers] = useState([]);
  // dropdowns
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [banks, setBanks] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [paymentGroups, setPaymentGroups] = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [officeCodes, setOfficeCodes] = useState([]);
  const [paymentBanks, setPaymentBanks] = useState([]);
  const [companyCodes, setCompanyCodes] = useState([]);
  const [salaryConfig, setSalaryConfig] = useState({});
  const [sameAsCurrentAddress, setSameAsCurrentAddress] = useState(false);
const [showSalarySummary, setShowSalarySummary] = useState(false);
const [stations, setStations] = useState([]);           // master list
const [showStationDropdown, setShowStationDropdown] = useState(false);
  const [documents, setDocuments] = useState([]);
const [documentsLoading, setDocumentsLoading] = useState(false);

  const defaultLocations = [
    { code: "Work from Home", description: "Work from Home" },
    { code: "Work from Office", description: "Work from Office" },
    { code: "Work from Client", description: "Work from Client" },
  ];

  const maritalStatusOptions = [
    { code: "Married", description: "Married" },
    { code: "Unmarried", description: "Unmarried" },
    { code: "Not declared", description: "Not declared" },
  ];

  const bloodGroupOptions = [
    { code: "A+", description: "A+" },
    { code: "A-", description: "A-" },
    { code: "B+", description: "B+" },
    { code: "B-", description: "B-" },
    { code: "O+", description: "O+" },
    { code: "O-", description: "O-" },
    { code: "AB+", description: "AB+" },
    { code: "AB-", description: "AB-" },
  ];

  // resource state
  const [resourceData, setResourceData] = useState({
      mav_UserID: "", 
    name: "",
    role: "",
    department: "",
    resourceId: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    employeeType: "",
    paymentGroup: "",
    emailId: "",
    companyCode: 0,
    paymentBank: "",
    costCenter: "",
    defaultLocation: "",
    officeCode: "",
    dob: "",
    fathersName: "",
    spouseName: "",
    maritalStatus: "",
    phoneNumber: "",
    panNumber: "",
    aadharNumber: "",
    bloodGroup: "",
    uanNumber: "",
    urlAadharCard: "",
    urlPanCard: "",
    emergencyContactName: "",
    emergencyContactRelation: "",
    emergencyContactPhoneNumber: "",
    createdBy: user?.userId,
    organisationId: user?.organisationId,
    lineManager: "",
    dotLineManager: "",
    address1: "",
    address2: "",
    address3: "",
    address4: "",
    address5: "",
    address6: "",
    statusReason: "",
    doj: "",
    leftDate: "",
    confirmationDate: "",     // ✅ NEW
  gender: "",               // ✅ NEW
  personalEmailId: "",
stations: [], // array of stationId (GUID)

  salary: {
  basic: 0,
  hra: 0,
  ma: 0,
  ta: 0,
  splAll: 0,
  ca: 0,
  mobile: 0,
  da: 0,

  pf: 0,            // Employee PF
  esic: 0,          // Employee ESIC
  pfCompany: 0,     // Employer PF
  esicCompany: 0,   // Employer ESIC

  gross: 0,
  ctc: 0,
  net: 0,
}


  });

  // helper to format API datetime -> yyyy-mm-dd for input[type=date]
  const formatToDateInput = (isoLike) => {
    if (!isoLike) return "";
    const d = new Date(isoLike);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  useEffect(() => {
  const handleClickOutside = () => {
    setShowStationDropdown(false);
  };

  document.addEventListener("click", handleClickOutside);
  return () => document.removeEventListener("click", handleClickOutside);
}, []);


useEffect(() => {
  const fetchStations = async () => {
    try {
      const res = await axios.get(
        `${Base_URL}/SalaryProcess/GetStationsforResource/${user?.organisationId}`
      );
      setStations(
        Array.isArray(res.data) ? res.data.filter(s => s.active) : []
      );
    } catch (err) {
      toast.error("Failed to load stations");
    }
  };

  fetchStations();
}, []);

  const todayAsInputDate = () => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const res = await axios.get(
          `${Base_URL}/SalaryProcess/ResourceMastersByOrgId/${user?.organisationId}`,
        );
        setManagers(res.data || []);
      } catch (err) {
        toast.error("Failed to load manager list");
      }
    };

    if (user?.organisationId) {
      fetchManagers();
    }
  }, [user?.organisationId]);

  // fetch dropdowns + salaryConfig + companyCodes
  useEffect(() => {
    const fetchAllDropdowns = async () => {
      try {
        const [
          rolesData,
          deptsData,
          banksData,
          empTypesData,
          paymentGroupsData,
          costCentersData,
          officeCodesData,
          paymentBanksData,
          salaryconfig,
          companyCodeData,
        ] = await Promise.all([
          fetchRoles(),
          fetchDepartments(),
          fetchBanks(user?.organisationId),
          fetchEmployeeTypes(),
          fetchPaymentGroups(),
          fetchCostCenters(),
          fetchOfficeCodes(user?.organisationId),
          fetchPaymentBanks(user?.organisationId),
          fetchSalaryConfig(user?.organisationId),
          getCompanyCodesByOrganisation(user?.organisationId),
        ]);

        setRoles(rolesData || []);
        setDepartments(deptsData || []);
        setBanks(banksData || []);
        setEmployeeTypes(empTypesData || []);
        setPaymentGroups(paymentGroupsData || []);
        setCostCenters(costCentersData || []);
        setOfficeCodes(officeCodesData || []);
        setPaymentBanks(paymentBanksData || []);
        setSalaryConfig(salaryconfig || {});
        setCompanyCodes(companyCodeData || []);
      } catch (err) {
        toast.error(`Error loading dropdown data: ${err?.message || err}`);
      }
    };

    if (user?.organisationId) {
      fetchAllDropdowns();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.organisationId]);
  useEffect(() => {
  if (resourceData.doj) {
    const dojDate = new Date(resourceData.doj);
    dojDate.setMonth(dojDate.getMonth() + 6);

    setResourceData(prev => ({
      ...prev,
      confirmationDate: dojDate.toISOString().split("T")[0],
    }));
  } else {
    setResourceData(prev => ({
      ...prev,
      confirmationDate: "",
    }));
  }
}, [resourceData.doj]);
// useEffect(() => {
//   if (resourceData.doj) {
//     const dojDate = new Date(resourceData.doj);
//     dojDate.setMonth(dojDate.getMonth() + 6);

//     setResourceData(prev => ({
//       ...prev,
//       confirmationDate: dojDate.toISOString().split("T")[0],
//     }));
//   } else {
//     setResourceData(prev => ({
//       ...prev,
//       confirmationDate: "",
//     }));
//   }
// }, [resourceData.doj]);

  // fetch resource by id and populate
  useEffect(() => {
    const getResource = async () => {
      setFetchingData(true);
      try {
        const res = await fetch(
          `${Base_URL}/Resource/GetResourceById/id?id=${encodeURIComponent(id)}`,
        );
        if (!res.ok) {
          throw new Error(`Failed to fetch resource (status ${res.status})`);
        }
        const data = await res.json();
        console.log(data, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
        const apiStations = Array.isArray(data?.stations)
  ? data.stations
      .filter(s => s.active)
      .map(s => s.stationId)
  : [];

        const apiResource = data?.resource || {};
        const apiSalary = data?.salary || {};
        const address = data?.address || {};
        // map salary with backward compatibility (basicPlusDa / other)
        const basic =
          parseFloat(apiSalary.basic ?? apiSalary.basicPlusDa ?? 0) || 0;
        const hra = parseFloat(apiSalary.hra ?? 0) || 0;
        const ma = parseFloat(apiSalary.ma ?? 0) || 0;
        const ta = parseFloat(apiSalary.ta ?? 0) || 0;
        const splAll =
          parseFloat(apiSalary.splAll ?? apiSalary.other ?? 0) || 0;
        const ca = parseFloat(apiSalary.ca ?? 0) || 0;
        const mobile = parseFloat(apiSalary.mobile ?? 0) || 0;
        const pf = parseFloat(apiSalary.pfEmployee ?? 0) || 0;
        const esic =
          parseFloat(apiSalary.esicEmployee ?? apiSalary.esi ?? 0) || 0;
        const da = parseFloat(apiSalary.da ?? 0) || 0;
        const pfCompany = parseFloat(apiSalary.pfCompany ?? 0) || 0;
        const esicCompany = parseFloat(apiSalary.esicCompany ?? 0) || 0;
        const other = ca + mobile + da;
        const gross =
          basic +
          hra +
          ma +
          ta +
          splAll 
          // other -
          // (pf || 0) -
          // (esic || 0) +
          // pfCompany +
          // esicCompany;

        setResourceData((prev) => ({
          ...prev,
          name: apiResource.name ?? "",
            mav_UserID: apiResource.mav_UserID ?? apiResource.resourceId ?? "",
          role: apiResource.role ?? "",
          department: apiResource.department ?? "",
          resourceId: apiResource.resourceId ?? "",
          bankName: apiResource.bankName ?? "",
          accountNo: apiResource.accountNo ?? "",
          ifscCode: apiResource.ifscCode ?? "",
          employeeType: apiResource.employeeType ?? "",
          paymentGroup: apiResource.paymentGroup ?? "",
          emailId: apiResource.emailId ?? "",
          companyCode: apiResource.companyCode ?? prev.companyCode ?? 0,
          paymentBank: apiResource.paymentBank ?? "",
          costCenter: apiResource.costCenter ?? "",
          defaultLocation: apiResource.defaultLocation ?? "",
          officeCode: apiResource.officeCode ?? "",
          dob: formatToDateInput(apiResource.dob),
          fathersName: apiResource.fathersName ?? "",
          spouseName: apiResource.spouseName ?? "",
          maritalStatus: apiResource.maritalStatus ?? "",
          phoneNumber: apiResource.phoneNumber ?? "",
          panNumber: apiResource.panNumber ?? "",
          aadharNumber: apiResource.aadharNumber ?? "",
          bloodGroup: apiResource.bloodGroup ?? "",
          uanNumber: apiResource.uanNumber ?? "",
          urlAadharCard: apiResource.urlAadharCard ?? "",
          urlPanCard: apiResource.urlPanCard ?? "",
          emergencyContactName: apiResource.emergencyContactName ?? "",
          emergencyContactRelation: apiResource.emergencyContactRelation ?? "",
          lineManager: apiResource.lineManager ?? "",
          dotLineManager: apiResource.dotLineManager ?? "",
          emergencyContactPhoneNumber:
            apiResource.emergencyContactPhoneNumber ?? "",
          organisationId: apiResource.organisationId ?? user?.organisationId,
          statusReason: apiResource.statusReason ?? "Prohibition",
          doj: formatToDateInput(apiResource.doj),
          leftDate: formatToDateInput(apiResource.leftDate),
          address1: address?.address1 ?? "",
          address2: address?.address2 ?? "",
          address3: address?.address3 ?? "",
          address4: address?.address4 ?? "",
          address5: address?.address5 ?? "",
          address6: address?.address6 ?? "",
            gender: apiResource.gender ?? "",
  personalEmailId: apiResource.personalEmailId ?? "",
  // confirmationDate: formatToDateInput(apiResource.confirmationDate),
          salary: {
            basic,
            hra,
            ma,
            ta,
            splAll,
            ca,
            mobile,
            pf,
            esic,
            da,
            pfCompany,
            esicCompany,
            other: Number(other.toFixed(2)),
            gross: Number(gross.toFixed(2)),
            ctc:gross+pfCompany+esicCompany,
            net:gross-(pf+esic),
          },
          stations: apiStations,
        }));
        const sameAddress =
          apiResource.address1 &&
          apiResource.address1 === apiResource.address4 &&
          apiResource.address2 === apiResource.address5 &&
          apiResource.address3 === apiResource.address6;

        setSameAsCurrentAddress(!!sameAddress);

        // show spouse if maritalStatus is Married
        setShowSpouseName(
          (apiResource?.maritalStatus ?? "").toString() === "Married",
        );
      } catch (error) {
        toast.error(`Error loading resource: ${error?.message || error}`);
      } finally {
        setFetchingData(false);
      }
    };

    if (id) getResource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, user?.organisationId]);
  const handleStationChange = (stationId) => {
  setResourceData(prev => {
    const exists = prev.stations.includes(stationId);
    return {
      ...prev,
      stations: exists
        ? prev.stations.filter(id => id !== stationId)
        : [...prev.stations, stationId],
    };
  });
};

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "maritalStatus") {
  //     const isMarried = value === "Married";
  //     setShowSpouseName(isMarried);
  //     if (!isMarried) {
  //       setResourceData((prev) => ({
  //         ...prev,
  //         [name]: value,
  //         spouseName: "",
  //       }));
  //       return;
  //     }
  //   }

  //   setResourceData((prev) => ({
  //     ...prev,
  //     [name]: name === "companyCode" ? parseInt(value) || 0 : value,
  //   }));
  // };
  useEffect(() => {
    console.log('🔄 UpdateResource component mounted');
    console.log('User from auth:', user);
    console.log('Resource ID from params:', id);
  }, []);

    useEffect(() => {
    console.log('📊 resourceData updated:', resourceData);
console.log('resourceData.mav_UserID:', resourceData.mav_UserID);

  }, [resourceData]);



 const handleDocumentView = async (doc) => {
    try {
      console.log('👁️ Viewing document:', doc);
      
      if (doc.url) {
        console.log('📄 Opening document URL:', doc.url);
        window.open(doc.url, "_blank");
      } else if (doc.documentId && !doc.documentId.includes('-')) {
        // If we have a database document ID (not a generated one), try to view via API
        console.log('🔍 Fetching document via API with ID:', doc.documentId);
        const result = await hrDocumentService.viewDocument(doc.documentId);
        console.log('✅ View document result:', result);
      } else {
        console.warn('⚠️ No valid document URL or ID available');
        toast.error("Cannot view document - no valid link available");
      }
    } catch (error) {
      console.error('❌ Error viewing document:', error);
      toast.error(`Cannot view document: ${error.message}`);
    }
  };

  const loadUserDocuments = async () => {
    setDocumentsLoading(true);
    try {
      // Correct property access - check the API response structure
      console.log('🔄 Loading documents for user...');
      console.log('resourceData structure:', resourceData);
      console.log('resourceData.resource:', resourceData.resource);
 console.log('resourceData.mav_UserID:', resourceData.mav_UserID);

      console.log('resourceData.resource?.organisationId:', resourceData.resource?.organisationId);
      
   const userId = resourceData.mav_UserID || resourceData.resourceId;
const organisationId = resourceData.organisationId || user?.organisationId;

      
      if (!userId) {
        console.error('❌ No user ID available');
        toast.error("User ID not found in resource data");
        return;
      }

      console.log(`📋 Fetching documents for User ID: ${userId}, Org ID: ${organisationId}`);
      const response = await hrDocumentService.getUserDocuments(userId);
      
      console.log('📥 API Response:', response);
      console.log('📥 Documents array:', response.documents);
      
      const apiDocuments = response.documents || [];

      const expectedDocumentTypes = [
        "PAN Card",
        "Aadhaar Card",
        "Passport",
        "Cancelled Cheque",
        "Bank Passbook",
        "Bank Statement",
      ];

      console.log('📋 Expected document types:', expectedDocumentTypes);
      console.log('📄 API documents received:', apiDocuments);

      // Create a map of existing documents by type
      const uploadedDocsMap = {};
      apiDocuments.forEach(doc => {
        const docType = doc.documentType?.trim();
        console.log(`📄 Processing document: ${docType}`, doc);
        if (docType) {
          uploadedDocsMap[docType] = {
            documentId: doc.documentId,
            url: doc.url,
            fileName: doc.fileName || doc.documentType,
            uploaded: true
          };
        }
      });

      console.log('🗺️ Uploaded docs map:', uploadedDocsMap);

      // Create final documents array with all expected types
      const finalDocs = expectedDocumentTypes.map(type => {
        const uploadedDoc = uploadedDocsMap[type];
        console.log(`🔍 Checking ${type}:`, uploadedDoc);
        
        if (uploadedDoc) {
          return {
            documentId: uploadedDoc.documentId,
            documentType: type,
            url: uploadedDoc.url,
            fileName: uploadedDoc.fileName,
            uploaded: true
          };
        }
        
        // Return default for unuploaded documents
        return {
          documentId: type.toLowerCase().replace(/\s+/g, "-"),
          documentType: type,
          url: null,
          fileName: null,
          uploaded: false
        };
      });

      console.log('✅ Final documents:', finalDocs);
      console.log(`📊 Total documents: ${finalDocs.length}, Uploaded: ${finalDocs.filter(d => d.uploaded).length}`);
      setDocuments(finalDocs);
      
    } catch (err) {
      console.error('❌ Error loading documents:', err);
      console.error('❌ Error details:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status
      });
      toast.error(`Failed to load documents: ${err.message}`);
      
      // Initialize with default documents if API fails
      const defaultDocs = [
        { documentId: 'pan-card', documentType: 'PAN Card', url: null, fileName: null, uploaded: false },
        { documentId: 'aadhaar-card', documentType: 'Aadhaar Card', url: null, fileName: null, uploaded: false },
        { documentId: 'passport', documentType: 'Passport', url: null, fileName: null, uploaded: false },
        { documentId: 'cancelled-cheque', documentType: 'Cancelled Cheque', url: null, fileName: null, uploaded: false },
        { documentId: 'bank-passbook', documentType: 'Bank Passbook', url: null, fileName: null, uploaded: false },
        { documentId: 'bank-statement', documentType: 'Bank Statement', url: null, fileName: null, uploaded: false }
      ];
      console.log('📋 Loading default documents due to error');
      setDocuments(defaultDocs);
    } finally {
      setDocumentsLoading(false);
    }
  };

  // Update the handleDocumentUpload function
  const handleDocumentUpload = async (documentType, file) => {
    try {
      console.log('📤 Starting document upload...');
      console.log('documentType:', documentType);
      console.log('file:', file);
      
const userId = resourceData.mav_UserID || resourceData.resourceId;
const organisationId = resourceData.organisationId || user?.organisationId;

      
      console.log('👤 User info:', { userId, organisationId });
      
      if (!userId || !organisationId) {
        toast.error("User information not available");
        console.error('❌ Missing user info:', { userId, organisationId });
        return;
      }

      console.log('🚀 Calling HR document service...');
      const result = await hrDocumentService.uploadDocumentForUser(userId, organisationId, documentType, file);
      console.log('✅ Upload result:', result);
      
      toast.success("Document Uploaded Successfully");
      
      // Reload documents
      console.log('🔄 Reloading documents after upload...');
      await loadUserDocuments();
      
    } catch (error) {
      console.error('❌ Upload failed:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      toast.error(`Upload failed: ${error.response?.data?.message || error.message}`);
    }
  };

  // Update the handleDocumentDelete function
  const handleDocumentDelete = async (documentId) => {
    try {
      console.log('🗑️ Starting document deletion...');
      console.log('documentId:', documentId);
      
      await hrDocumentService.deleteDocument(documentId);
      console.log('✅ Document deleted successfully');
      
      toast.success("Document Deleted Successfully");
      
      // Reload documents
      console.log('🔄 Reloading documents after deletion...');
      await loadUserDocuments();
      
    } catch (error) {
      console.error('❌ Delete failed:', error);
      console.error('❌ Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      toast.error(`Delete failed: ${error.response?.data?.message || error.message}`);
    }
  };

  // Update the useEffect to trigger document loading when resource data is loaded
  useEffect(() => {
if ((resourceData.mav_UserID || resourceData.resourceId) && !fetchingData) {

      console.log('🎯 Resource data loaded, fetching documents...');
 console.log('User ID available:', resourceData.mav_UserID || resourceData.resourceId);
console.log('Organisation ID:', resourceData.organisationId);

      loadUserDocuments();
    }
  }, [resourceData.resource?.mav_UserID, fetchingData]);









  const handleChange = (e) => {
    const { name, value } = e.target;

    // ✅ If status becomes "Left"
    if (name === "statusReason" && (value === "Left" || value === "Resigned")) {
      setResourceData((prev) => ({
        ...prev,
        statusReason: value,
        leftDate: prev.leftDate || todayAsInputDate(),
         // auto-set today
      }));
      return;
    }

    // ✅ If status changes away from "Left"
    if (name === "statusReason" && (value !== "Left" || value !== "Resigned")) {
      setResourceData((prev) => ({
        ...prev,
        statusReason: value,
        leftDate: "", // clear left date
      }));
      return;
    }

    setResourceData((prev) => ({
      ...prev,
      [name]: name === "companyCode" ? parseInt(value) || 0 : value,
    }));
  };

  const statusReasonOptions = [
    { code: "Prohibition", description: "Prohibition" },
    { code: "Confirmation", description: "Confirmation" },
    { code: "Resigned", description: "Resigned" },
    { code: "Left", description: "Left" },
  ];

 const handleSalaryChange = (e) => {
  const { name, value } = e.target;
  const numeric = value === "" ? 0 : parseFloat(value);

  setResourceData((prev) => {
    const s = {
      ...prev.salary,
      [name]: isNaN(numeric) ? 0 : numeric,
    };

    // 1️⃣ Gross = sum of all allowances (exclude PF & ESIC)
    const gross =
      (s.basic || 0) +
      (s.hra || 0) +
      (s.ma || 0) +
      (s.ta || 0) +
      (s.splAll || 0) +
      (s.ca || 0) +
      (s.mobile || 0) +
      (s.da || 0);

    // 2️⃣ CTC = Gross + Employer PF + Employer ESIC
    const ctc =
      gross +
      (s.pfCompany || 0) +
      (s.esicCompany || 0);

    // 3️⃣ Net Salary = Gross - Employee PF - Employee ESIC
    const net =
      gross -
      (s.pf || 0) -
      (s.esic || 0);

    return {
      ...prev,
      salary: {
        ...s,
        gross: Number(gross.toFixed(2)),
        ctc: Number(ctc.toFixed(2)),
        net: Number(net.toFixed(2)),
      },
    };
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

        const payload = {
      ...resourceData,
      leftDate:
        resourceData.leftDate === ""
          ? null
          : resourceData.leftDate,
      dob:
        resourceData.dob === ""
          ? null
          : resourceData.dob,
      doj:
        resourceData.doj === ""
          ? null
          : resourceData.doj,
    };
      const res = await axios.put(
        `${Base_URL}/Resource/UpdateResourceMasters`,
         payload,
      );
      if (res.data != null) {
        toast.success(`${res?.data} ${resourceData.name} Updated Successfully`);
      }
    } catch (err) {
      toast.error(`Error updating resource: ${err?.message || err}`);
    } finally {
      setLoading(false);
    }
  };
  const handleSameAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsCurrentAddress(checked);

    if (checked) {
      setResourceData((prev) => ({
        ...prev,
        address4: prev.address1,
        address5: prev.address2,
        address6: prev.address3,
      }));
    } else {
      setResourceData((prev) => ({
        ...prev,
        address4: "",
        address5: "",
        address6: "",
      }));
    }
  };
  return (
    <div className="container update-resource-master-fields">
      <h2 className="fields-title">Update Resource</h2>

      <Form onSubmit={handleSubmit} className="fields-form">
        <Accordion defaultActiveKey="0" alwaysOpen>
          {/* Employee Details */}
          <div className="_EmployeeDetailsContainer">
            {" "}
            <Accordion.Item eventKey="0">
              <Accordion.Header as="div" className="_DetailsHeader">
                <div className="details-header-content employee-header">
                  {/* LEFT: icon + title */}
                  <div className="employee-header-left">
                    <div className="details-icon-card">
                      <FaUser />
                    </div>
                    <span className="details-header-text">
                      Employee Details
                    </span>
                  </div>

                  {/* RIGHT: headings only */}
                  <div className="employee-header-summary">
                    <span>Name · DOB · Role ....</span>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Name <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={resourceData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Date of Birth <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={resourceData.dob}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Role <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="role"
                        value={resourceData.role}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role.code} value={role.code}>
                            {role.code} - {role.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Department <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="department"
                        value={resourceData.department}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                      >
                        <option value="">Select Department</option>
                        {departments.map((dept) => (
                          <option key={dept.code} value={dept.code}>
                            {dept.code} - {dept.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Resource ID/Employee ID{" "}
                        <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="resourceId"
                        value={resourceData.resourceId}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Employee Type <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="employeeType"
                        value={resourceData.employeeType}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                      >
                        <option value="">Select Employee Type</option>
                        {employeeTypes.map((type) => (
                          <option key={type.code} value={type.code}>
                            {type.code} - {type.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Office Email ID <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="emailId"
                        value={resourceData.emailId}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Company Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="companyCode"
                        value={resourceData.companyCode}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Company</option>
                        {companyCodes.map((company) => (
                          <option
                            key={company.companyCode}
                            value={company.companyCode}
                          >
                            {company.companyCode} - {company.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Office Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="officeCode"
                        value={resourceData.officeCode}
                        onChange={handleChange}
                        required
                        disabled={fetchingData}
                      >
                        <option value="">Select Office Code</option>
                        {officeCodes.map((office) => (
                          <option key={office.code} value={office.code}>
                            {office.code} - {office.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Status Reason <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="statusReason"
                        value={resourceData.statusReason}
                        onChange={handleChange}
                        required
                      >
                        {statusReasonOptions.map((status) => (
                          <option key={status.code} value={status.code}>
                            {status.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  {(resourceData.statusReason === "Left"||resourceData.statusReason==="Resigned") && (
                    <Col xl={4} lg={4} md={6} sm={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Left Date <span className="text-red">*</span>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="leftDate"
                          value={resourceData.leftDate}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  )}

                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Date of Joining <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="doj"
                        value={resourceData.doj}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
  <Form.Group className="mb-3">
    <Form.Label>Confirmation Date</Form.Label>
    <Form.Control
      type="date"
      name="confirmationDate"
      value={resourceData.confirmationDate}
      readOnly
      disabled
    />
  </Form.Group>
</Col>


  <Col md={4}>
    <Form.Group className="mb-3 station-dropdown-group">
      <Form.Label>
        Stations <span className="text-red">*</span>
      </Form.Label>

      <Form.Control
        ref={stationInputRef}
        readOnly
        className="station-dropdown-input"
      value={
  resourceData.stations.length
    ? stations
        .filter(st => resourceData.stations.includes(st.recordGuid))
        .map(st => st.stationName)
        .join(", ")
    : "Select Stations"
}

        onClick={(e) => {
          e.stopPropagation();

          const rect = stationInputRef.current.getBoundingClientRect();
          setStationDropdownStyle({
            position: "fixed",
            top: rect.bottom + 4,
            left: rect.left,
            width: rect.width,
            zIndex: 10000,
          });

          setShowStationDropdown(!showStationDropdown);
        }}
      />

      {showStationDropdown &&
        createPortal(
          <div
            className="station-dropdown-menu"
            style={stationDropdownStyle}
            onClick={(e) => e.stopPropagation()}
          >
            {stations.map((station) => (
              <Form.Check
                key={station.recordGuid}
                type="checkbox"
                label={station.stationName}
                checked={resourceData.stations.includes(station.recordGuid)}
                onChange={() => handleStationChange(station.recordGuid)}
                className="station-dropdown-item"
              />
            ))}
          </div>,
          document.body
        )}
    </Form.Group>
  </Col>
</Row>

                
                
              </Accordion.Body>
            </Accordion.Item>
          </div>

          {/* Personal Details */}
          <Accordion.Item eventKey="1">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaIdCard />
                  </div>
                  <span className="details-header-text">Personal Details</span>
                </div>

                {/* RIGHT: headings only */}

                <div className="employee-header-summary">
                  <span>Father's Name · Marital Status....</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
  <Form.Group className="mb-3">
    <Form.Label>Gender</Form.Label>
    <Form.Select
      name="gender"
      value={resourceData.gender}
      onChange={handleChange}
    >
      <option value="">Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Transgender">Transgender</option>
    </Form.Select>
  </Form.Group>
</Col>
<Col xl={4} lg={4} md={6} sm={12}>
  <Form.Group className="mb-3">
    <Form.Label>Personal Email ID</Form.Label>
    <Form.Control
      type="email"
      name="personalEmailId"
      value={resourceData.personalEmailId}
      onChange={handleChange}
      placeholder="Enter personal email"
    />
  </Form.Group>
</Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Father's Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="fathersName"
                      value={resourceData.fathersName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Marital Status</Form.Label>
                    <Form.Select
                      name="maritalStatus"
                      value={resourceData.maritalStatus}
                      onChange={handleChange}
                    >
                      <option value="">Select Marital Status</option>
                      {maritalStatusOptions.map((status) => (
                        <option key={status.code} value={status.code}>
                          {status.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {showSpouseName && (
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Spouse Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="spouseName"
                        value={resourceData.spouseName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                )}

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      value={resourceData.phoneNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>PAN Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="panNumber"
                      value={resourceData.panNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Aadhar Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="aadharNumber"
                      value={resourceData.aadharNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Blood Group</Form.Label>
                    <Form.Select
                      name="bloodGroup"
                      value={resourceData.bloodGroup}
                      onChange={handleChange}
                    >
                      <option value="">Select Blood Group</option>
                      {bloodGroupOptions.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>UAN Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="uanNumber"
                      value={resourceData.uanNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <hr />
                <h6 className="mb-3">Current Address</h6>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={resourceData.address1}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={resourceData.address2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="address3"
                      value={resourceData.address3}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Permanent address same as current address"
                    checked={sameAsCurrentAddress}
                    onChange={handleSameAddressChange}
                  />
                </Form.Group>
                <h6 className="mb-3">Permanent Address</h6>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address4"
                      value={resourceData.address4}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address5"
                      value={resourceData.address5}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address Line 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="address6"
                      value={resourceData.address6}
                      onChange={handleChange}
                      disabled={sameAsCurrentAddress}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Bank Details */}
          <Accordion.Item eventKey="2">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUniversity />
                  </div>
                  <span className="details-header-text">Bank Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Bank Name · Account No. ....</span>
                </div>
              </div>
            </Accordion.Header>{" "}
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <Form.Select
                      name="bankName"
                      value={resourceData.bankName}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.code} value={bank.code}>
                          {bank.code} - {bank.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account No</Form.Label>
                    <Form.Control
                      type="text"
                      name="accountNo"
                      value={resourceData.accountNo}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>IFSC Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="ifscCode"
                      value={resourceData.ifscCode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Bank</Form.Label>
                    <Form.Select
                      name="paymentBank"
                      value={resourceData.paymentBank}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Payment Bank</option>
                      {paymentBanks.map((bank, index) => (
                        <option key={index} value={bank.code}>
                          {bank.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Group</Form.Label>
                    <Form.Select
                      name="paymentGroup"
                      value={resourceData.paymentGroup}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Payment Group</option>
                      {paymentGroups.map((group) => (
                        <option key={group.code} value={group.code}>
                          {group.code} - {group.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Other Details */}
          <Accordion.Item eventKey="3">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUsers />
                  </div>
                  <span className="details-header-text">Other Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Cost Center · Default Location ....</span>
                </div>
              </div>
            </Accordion.Header>{" "}
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Cost Center</Form.Label>
                    <Form.Select
                      name="costCenter"
                      value={resourceData.costCenter}
                      onChange={handleChange}
                      disabled={fetchingData}
                    >
                      <option value="">Select Cost Center</option>
                      {costCenters.map((center) => (
                        <option key={center.code} value={center.code}>
                          {center.code} - {center.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Default Location</Form.Label>
                    <Form.Select
                      name="defaultLocation"
                      value={resourceData.defaultLocation}
                      onChange={handleChange}
                    >
                      <option value="">Select Default Location</option>
                      {defaultLocations.map((location) => (
                        <option key={location.code} value={location.code}>
                          {location.code} - {location.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>URL Aadhar Card</Form.Label>
                    <Form.Control
                      type="text"
                      name="urlAadharCard"
                      value={resourceData.urlAadharCard}
                      onChange={handleChange}
                      placeholder="Enter URL for Aadhar Card"
                    />
                  </Form.Group>
                </Col> */}

                {/* <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>URL PAN Card</Form.Label>
                    <Form.Control
                      type="text"
                      name="urlPanCard"
                      value={resourceData.urlPanCard}
                      onChange={handleChange}
                      placeholder="Enter URL for PAN Card"
                    />
                  </Form.Group>
                </Col> */}

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactName"
                      value={resourceData.emergencyContactName}
                      onChange={handleChange}
                      placeholder="Enter emergency contact name"
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Relation</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactRelation"
                      value={resourceData.emergencyContactRelation}
                      onChange={handleChange}
                      placeholder="Enter relation (e.g., Father, Mother)"
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Emergency Contact Phone</Form.Label>
                    <Form.Control
                      type="text"
                      name="emergencyContactPhoneNumber"
                      value={resourceData.emergencyContactPhoneNumber}
                      onChange={handleChange}
                      placeholder="Enter emergency contact phone"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>

          {/* Salary Details */}
          <Accordion.Item eventKey="4">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaMoneyBillWave />
                  </div>
                  <span className="details-header-text">Salary Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Basic · HRA · MA ....</span>
                </div>
              </div>
            </Accordion.Header>{" "}
            <Accordion.Body>
            <h3 className="salary-section-title">All Allowances</h3>

<Row>
  {salaryConfig?.basicPay && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>Basic</Form.Label>
        <Form.Control
          type="number"
          name="basic"
          value={resourceData.salary.basic}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.hra && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>HRA</Form.Label>
        <Form.Control
          type="number"
          name="hra"
          value={resourceData.salary.hra}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ma && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>MA</Form.Label>
        <Form.Control
          type="number"
          name="ma"
          value={resourceData.salary.ma}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ta && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>TA</Form.Label>
        <Form.Control
          type="number"
          name="ta"
          value={resourceData.salary.ta}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.da && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>DA</Form.Label>
        <Form.Control
          type="number"
          name="da"
          value={resourceData.salary.da}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.ca && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>CA</Form.Label>
        <Form.Control
          type="number"
          name="ca"
          value={resourceData.salary.ca}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.mobileInternetAllowence && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>Mobile Allowance</Form.Label>
        <Form.Control
          type="number"
          name="mobile"
          value={resourceData.salary.mobile}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  <Col xl={3} lg={3} md={6} sm={12}>
    <Form.Group className="mb-3">
      <Form.Label>Spl Allowance</Form.Label>
      <Form.Control
        type="number"
        name="splAll"
        value={resourceData.salary.splAll}
        onChange={handleSalaryChange}
      />
    </Form.Group>
  </Col>
</Row>
<hr />
<h3 className="salary-section-title">PF & ESIC</h3>

<Row>
  {salaryConfig?.pf && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>PF (Employer)</Form.Label>
        <Form.Control
          type="number"
          name="pfCompany"
          value={resourceData.salary.pfCompany}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.esi && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>ESIC (Employer)</Form.Label>
        <Form.Control
          type="number"
          name="esicCompany"
          value={resourceData.salary.esicCompany}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.pf && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>PF (Employee)</Form.Label>
        <Form.Control
          type="number"
          name="pf"
          value={resourceData.salary.pf}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}

  {salaryConfig?.esi && (
    <Col xl={3} lg={3} md={6} sm={12}>
      <Form.Group className="mb-3">
        <Form.Label>ESIC (Employee)</Form.Label>
        <Form.Control
          type="number"
          name="esic"
          value={resourceData.salary.esic}
          onChange={handleSalaryChange}
        />
      </Form.Group>
    </Col>
  )}
</Row>
<hr />
<h3 className="salary-section-title">Summary</h3>

<Row>
  <Col xl={3} lg={3} md={6} sm={12}>
    <Form.Group className="mb-3">
      <Form.Label>Gross</Form.Label>
      <Form.Control
        type="number"
        value={resourceData.salary.gross}
        readOnly
      />
    </Form.Group>
  </Col>
</Row>

<div
  style={{ cursor: "pointer", fontWeight: 600, color: "rgb(69, 127, 146)"}}
  onClick={() => setShowSalarySummary((p) => !p)}
>
  {showSalarySummary ? "▼ Hide Salary Summary" : "▶ Show Salary Summary"}
</div>

{showSalarySummary && (
  <table className="table table-bordered text-center mt-3">
    <thead>
      <tr>
        <th></th>
        <th>Gross</th>
        <th>CTC</th>
        <th>Net</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Monthly</th>
        <td>{resourceData.salary.gross.toFixed(2)}</td>
        <td>{resourceData.salary.ctc.toFixed(2)}</td>
        <td>{resourceData.salary.net.toFixed(2)}</td>
      </tr>
      <tr>
        <th>Annual</th>
        <td>{(resourceData.salary.gross * 12).toFixed(2)}</td>
        <td>{(resourceData.salary.ctc * 12).toFixed(2)}</td>
        <td>{(resourceData.salary.net * 12).toFixed(2)}</td>
      </tr>
    </tbody>
  </table>
)}

            </Accordion.Body>
          </Accordion.Item>

          {/* Manager Details */}
          <Accordion.Item eventKey="5">
            <Accordion.Header as="div" className="_DetailsHeader">
              <div className="details-header-content employee-header">
                {/* LEFT: icon + title */}
                <div className="employee-header-left">
                  <div className="details-icon-card">
                    <FaUserTie />
                  </div>
                  <span className="details-header-text">Manager Details</span>
                </div>

                {/* RIGHT: headings only */}
                <div className="employee-header-summary">
                  <span>Line Manager · Dot Line Manager ....</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Line Manager <span className="text-red"></span>
                    </Form.Label>
                    <Form.Select
                      name="lineManager"
                      value={resourceData.lineManager}
                      onChange={handleChange}
                    >
                      <option value="">Select Line Manager</option>
                      {managers.map((mgr) => (
                        <option key={mgr.resourceId} value={mgr.resourceId}>
                          {mgr.name} ({mgr.resourceId})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Dot Line Manager <span className="text-red"></span>
                    </Form.Label>
                    <Form.Select
                      name="dotLineManager"
                      value={resourceData.dotLineManager}
                      onChange={handleChange}
                    >
                      <option value="">Select Dot Line Manager</option>
                      {managers.map((mgr) => (
                        <option key={mgr.resourceId} value={mgr.resourceId}>
                          {mgr.name} ({mgr.resourceId})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>


{/* Documents Section */}
<Accordion.Item eventKey="6">
  <Accordion.Header as="div" className="_DetailsHeader">
    <div className="details-header-content employee-header">
      {/* LEFT: icon + title */}
      <div className="employee-header-left">
        <div className="details-icon-card">
          <FaFileAlt />
        </div>
        <span className="details-header-text">Documents</span>
      </div>

      {/* RIGHT: headings only */}
      <div className="employee-header-summary">
        <span>PAN · Aadhaar · Passport ....</span>
      </div>
    </div>
  </Accordion.Header>

  <Accordion.Body>
<DocumentsSection
  userId={resourceData.mav_UserID || resourceData.resourceId}
  organisationId={resourceData.organisationId || user?.organisationId}
  documents={documents}
  documentsLoading={documentsLoading}
  onRefreshDocuments={loadUserDocuments}
  onUploadDocument={handleDocumentUpload}
  onDeleteDocument={handleDocumentDelete}
  onViewDocument={handleDocumentView}
 onSaveQualifications={async (qualifications) => {
  try {
    console.group('🎓 onSaveQualifications in UpdateResource');
    console.log('📋 Received qualifications:', qualifications);
    
    // Debug each qualification
    qualifications.forEach((qual, index) => {
      console.log(`🔍 Qualification ${index}:`, {
        qualificationType: qual.qualificationType,
        institute: qual.institute,
        year: qual.year,
        grade: qual.grade,
        attachment: qual.attachment,
        attachmentType: qual.attachment?.constructor?.name,
        isFile: qual.attachment instanceof File,
        hasAttachment: !!qual.attachment
      });
    });
    
    const userId = resourceData.mav_UserID || resourceData.resourceId;
    const organisationId = resourceData.organisationId || user?.organisationId;
    
    console.log('👤 User info:', { userId, organisationId });
    
    if (!userId || !organisationId) {
      toast.error("User information not available");
      console.error('❌ Missing user info for qualifications');
      throw new Error('User information not available');
    }
    
    // Ensure all attachments are File objects
    const validatedQualifications = qualifications.map(qual => {
      if (!qual.attachment || !(qual.attachment instanceof File)) {
        console.error('❌ Invalid attachment:', qual.attachment);
        throw new Error(`Invalid file for ${qual.qualificationType}`);
      }
      return qual;
    });
    
    console.log('📦 Validated qualifications:', validatedQualifications);
    
    // Use HR qualification service for update section
    const response = await hrQualificationService.uploadQualificationsBulk(
      userId, 
      organisationId, 
      validatedQualifications
    );
    
    console.log('✅ Qualification upload response:', response);
    
    if (response.success) {
      toast.success(`${response.totalProcessed} qualification(s) saved successfully!`);
      
      // Refresh existing qualifications
      const refreshResponse = await hrQualificationService.getUserQualifications(userId);
      if (refreshResponse.success && Array.isArray(refreshResponse.qualifications)) {
        toast.success('Qualifications refreshed successfully!');
      }
    } else {
      toast.error(`Some errors occurred: ${response.errors?.join(', ') || 'Unknown error'}`);
    }
    
    return response;
  } catch (error) {
    console.error('❌ Failed to save qualifications:', error);
    console.error('❌ Error details:', error);
    
    // More specific error messages
    if (error.message.includes('required fields')) {
      toast.error('Please fill all required fields and upload files for each qualification');
    } else if (error.message.includes('Invalid file')) {
      toast.error('Invalid file attachment. Please re-upload the file.');
    } else {
      toast.error(`Failed to save qualifications: ${error.message}`);
    }
    throw error;
  } finally {
    console.groupEnd();
  }
}}
  isHRMode={true}  // Set to true for update section
/>
  </Accordion.Body>


</Accordion.Item>


        </Accordion>

        <div className="fields-btn-container" style={{ marginTop: 16 }}>
          <Button
            variant="primary"
            type="submit"
            className="fields-submit"
            disabled={loading || fetchingData}
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      </Form>

      {(loading || fetchingData) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default UpdateResource;
